import React from "react";
import { useAuth } from "@/hooks/useAuth";
import { cn } from "@/lib/utils";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useBranding } from "@/hooks/useBranding";
// The public pages' theme switcher. It used to sit here before a header
// redesign dropped the whole action row; the component, its Redux wiring and
// even the `.public-layout .liquid-toggle` overrides in globals.css never went
// away — only this mounting point did.
import ThemeToggleButton from "@/themes/ThemeToggleButton";

const Header = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const currentTheme = useSelector((state) => state.theme.theme);
  const { branding } = useBranding();

  const onHandleLogin = () => {
    navigate(isAuthenticated ? "/admin/dashboard" : "/login");
  };

  const isBaseRoutes = ["/", "/login", "/auth/accept-invite", "/reset-password", "/forgot-password", "/signup"].includes(location.pathname);
  const isHomeRoute = location.pathname === "/";
  const isLoginRoute = location.pathname === "/login";
  const isDark = currentTheme === "dark";

  const lightLogoSrc = branding?.logoUrl || branding?.logoDarkUrl || "/logo_light.svg";
  const darkLogoSrc = branding?.logoDarkUrl || branding?.logoUrl || "/logo_dark.svg";
  const logoAlt = branding?.appName || branding?.displayName || "IMS People Possible AI logo";

  return (
    <header
      className={cn(
        "w-full shrink-0 transition-colors duration-300 border-b border-border-primary ease-in-out",
        isBaseRoutes
          ? "absolute top-0 left-0 right-0 z-50"
          : "sticky top-0 z-50"
      )}
    >
      <nav
        className={cn(
          "w-full bg-transparent transition-colors duration-300 ease-in-out",
          isBaseRoutes ? "absolute top-0 left-0 z-50" : ""
        )}
      >
        <div
          className="
            w-full mx-auto
            px-6 sm:px-8 md:px-10 lg:px-12
            py-3 sm:py-4
            flex items-center justify-between
          "
        >
          <Link to="/" className="cursor-pointer block">
            <div className="relative w-28 sm:w-32 lg:w-40 h-10 sm:h-12 lg:h-14">
              <img
                src={lightLogoSrc}
                alt={logoAlt}
                className={cn(
                  "absolute inset-0 h-full w-full object-contain transition-opacity duration-500 ease-in-out",
                  isDark ? "opacity-0" : "opacity-100"
                )}
              />
              <img
                src={darkLogoSrc}
                alt=""
                aria-hidden="true"
                className={cn(
                  "absolute inset-0 h-full w-full object-contain transition-opacity duration-500 ease-in-out",
                  isDark ? "opacity-100" : "opacity-0"
                )}
              />
            </div>
          </Link>

          <div className="flex items-center gap-4">
            <ThemeToggleButton />
          </div>

        </div>
      </nav>
    </header>
  );
};

export default Header;